import { Fragment, useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import AccionaButton from '../../../../../components/AccionaButton';
import { MainContext } from '../../../../../context/MainContext';
import { getFile } from '../../../../../services/api/files';
import { getPRM } from '../../../../../services/api/prms';
import { docility } from '../../../../../utils/utils';
import { TableRow2575, TableRow50 } from './tableRow';
import MiniImg from './miniImg';
import { CommentRow, ResponseRow, TitleRow, WhiteRow, imgSetter } from './util';
import generatePDF from './generatePDF';
import moment from 'moment';
import { useSelector } from 'react-redux';

const Details = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { setLoading } = useContext(MainContext);
  const { project } = useOutletContext();
  const [prm, setPRM] = useState(null);
  const pid = project.id_project;
  const { idDetail: id } = useParams();
  const { me } = useSelector(({ auth }) => auth);

  const [pre_img_list, setPre_img_list] = useState([]);
  const [right_appearance_img_list, setRight_appearance_img_list] = useState(
    [],
  );
  const [limit_time_img_list, setLimit_time_img_list] = useState([]);

  const [added_substance_img_list, setAdded_substance_img_list] = useState([]);
  const [specimens_img_list, setSpecimens_img_list] = useState([]);
  const [signature_img_list, setSignature_img_list] = useState([]);

  const [createNCDisable, setCreateNCDisable] = useState(true);
  const listButton = (
    <AccionaButton
      msg={intl.formatMessage({ id: 'listNC' })}
      onClick={() =>
        navigate(
          `/app/project/${project.id_project}/quality/ocr/nc?nc=${prm?.non_conformity}`,
        )
      }
    />
  );
  const ncButton = (disabled) => (
    <AccionaButton
      msg={intl.formatMessage({ id: 'createNC' })}
      disabled={disabled || !me?.is_active}
      onClick={() => {
        navigate(
          `/app/project/${
            project.id_project
          }/quality/${project.normative_data.name.toLowerCase()}/nonConformity?prm=${id}`,
        );
      }}
    />
  );
  useEffect(() => {
    if (id) {
      setLoading(true);
      getPRM(id).then(({ data }) => {
        setPRM(data);
        if (!data.non_conformity) {
          if (
            data.defects_results === false ||
            data.substance_results === false
          ) {
            setCreateNCDisable(false);
          }
        }
      });
      setLoading(false);
    }
  }, [id, setLoading]);

  useEffect(() => {
    if (prm) {
      getFile(prm.pre_delivery_note_data.image_name, 'delivery').then(
        ({ data }) => setPre_img_list((prev) => [...prev, data]),
      );
      const baseName = `${prm.pre_delivery_note_data.docket_number}_${pid}`;
      imgSetter(
        prm.right_appearance_img,
        `${baseName}_right_appearance`,
        setRight_appearance_img_list,
        'PRM',
      );
      imgSetter(
        prm.limit_time_img,
        `${baseName}_limit_time`,
        setLimit_time_img_list,
        'PRM',
      );
      imgSetter(
        prm.added_substance_img,
        `${baseName}_added_substance`,
        setAdded_substance_img_list,
        'PRM',
      );
      imgSetter(
        prm.specimens_img,
        `${baseName}_specimens`,
        setSpecimens_img_list,
        'PRM',
      );
      getFile(`${baseName}_signature_0`, 'PRM').then(({ data }) =>
        setSignature_img_list([data]),
      );
    }
  }, [prm, pid]);

  const pdfButton = (
    <AccionaButton
      msg={intl.formatMessage({ id: 'generatePDF' })}
      classIcon="icon fas fa-file-invoice"
      disabled={!me?.is_active}
      onClick={async () => {
        setLoading(true);
        await generatePDF({
          prm,
          fileName: `${project.work_code}_PRM_${
            prm.prm_number
          }_${moment().format('YYYYMMDD')}`,
          intl,
          images: {
            prm_q1: pre_img_list,
            prm_q2: [...right_appearance_img_list, ...limit_time_img_list],
            prm_q3: added_substance_img_list,
            prm_q4: specimens_img_list,
            signature: signature_img_list,
          },
        });
        setLoading(false);
      }}
    />
  );

  const backButton = (
    <AccionaButton
      msg={intl.formatMessage({ id: 'back' })}
      onClick={() => navigate(-1)}
      classIcon="icon fas fa-chevron-left"
    />
  );

  if (prm)
    return (
      <div className="wrapper">
        <div
          className="form-row"
          style={{
            marginTop: '30px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          {pdfButton}
          {prm.non_conformity ? listButton : ncButton(createNCDisable)}
          {backButton}
        </div>
        <div className="dataTables_wrapper no-footer">
          <table className="dataTable">
            <tbody>
              <tr>
                <TableRow50
                  title={intl.formatMessage({ id: 'n_prm' })}
                  value={prm.prm_number}
                />
                <TableRow50
                  title={intl.formatMessage({ id: 'supplier' })}
                  value={
                    prm.pre_delivery_note_data?.model !== 'other'
                      ? intl.formatMessage({
                          id: prm.pre_delivery_note_data?.model,
                        })
                      : null
                  }
                />
              </tr>
              <tr>
                <TableRow50
                  title={intl.formatMessage({
                    id: 'pre_delivery_note_data.arriving_date',
                  })}
                  value={prm.pre_delivery_note_data.arriving_date}
                />
                <TableRow50
                  title={intl.formatMessage({ id: 'recipe' })}
                  value={prm.pre_delivery_note_data?.recipe}
                />
              </tr>
              <tr>
                <TableRow50
                  title={intl.formatMessage({ id: 'docket_number' })}
                  value={prm.pre_delivery_note_data.docket_number}
                />
                <TableRow50
                  title={intl.formatMessage({ id: 'detailed_location' })}
                  value={prm.pre_delivery_note_data?.detailed_location}
                />
              </tr>
              <WhiteRow />
              <ResponseRow
                title={intl.formatMessage({ id: 'PRM_Q1' })}
                value={intl.formatMessage({ id: 'PRM_Details_true' })}
              />
            </tbody>
          </table>
          <MiniImg fileList={pre_img_list} />
          <table className="dataTable">
            <tbody>
              <ResponseRow
                title={intl.formatMessage({ id: 'PRM_Q2' })}
                value={intl.formatMessage({
                  id: 'PRM_Details_' + String(prm.defects_results),
                })}
              />
            </tbody>
          </table>
          <MiniImg
            fileList={[...right_appearance_img_list, ...limit_time_img_list]}
          />
          <table className="dataTable">
            <tbody>
              <CommentRow
                values={[
                  prm.right_appearance_comments,
                  prm.limit_time_comments,
                  prm.defects_results_comments,
                ]}
              />
              <WhiteRow />
              <ResponseRow
                title={intl.formatMessage({ id: 'PRM_Q3' })}
                value={intl.formatMessage({
                  id: 'PRM_Details_' + String(prm.substance_results),
                })}
              />
            </tbody>
          </table>
          <MiniImg fileList={added_substance_img_list} />
          <table className="dataTable">
            <tbody>
              <CommentRow
                values={[
                  prm.added_substance_comments,
                  prm.substance_results_comments,
                ]}
              />
              <WhiteRow />
              <ResponseRow
                title={intl.formatMessage({ id: 'PRM_Q4' })}
                value={intl.formatMessage({
                  id:
                    'PRM_Details_0' +
                    String(prm.pre_delivery_note_data.mash_control),
                })}
              />
            </tbody>
          </table>
          {prm.pre_delivery_note_data.specimens_number ? (
            <Fragment>
              <table className="dataTable">
                <tbody>
                  <tr>
                    <TableRow2575
                      title={intl.formatMessage({ id: 'specimens_number' })}
                      value={prm.pre_delivery_note_data.specimens_number}
                    />
                  </tr>
                  <tr>
                    <TableRow2575
                      title={intl.formatMessage({ id: 'slump' })}
                      value={`${prm.pre_delivery_note_data?.slump}`}
                    />
                  </tr>
                  <tr>
                    <TableRow2575
                      title={intl.formatMessage({ id: 'consistency' })}
                      value={intl.formatMessage({
                        id: docility(prm.pre_delivery_note_data?.slump),
                      })}
                    />
                  </tr>
                </tbody>
              </table>
              <MiniImg fileList={specimens_img_list} />
              <table className="dataTable">
                <tbody>
                  <CommentRow values={[prm.specimens_comments]} />
                  <WhiteRow />
                </tbody>
              </table>
            </Fragment>
          ) : null}
          <table className="dataTable">
            <tbody>
              <TitleRow title={intl.formatMessage({ id: 'signature' })} />
            </tbody>
          </table>
          <MiniImg fileList={signature_img_list} />
        </div>
      </div>
    );
  else return null;
};

export default Details;
